import React from 'react';

import DescriptionContext from './DescriptionContext';
import { IDescriptionList } from './interfaces';

export const DescriptionList: React.FC<IDescriptionList> = ({
  children,
  data,
  stripEmpty = true,
}) => {
  return (
    <DescriptionContext.Provider
      value={{
        data,
        stripEmpty,
      }}
    >
      {children}
    </DescriptionContext.Provider>
  );
};
